export default __webpack_public_path__ + "static/growth-bdb57298bf17d37f8151be67c1d22fe3.png";